import { cn } from '@heidi/utils';

/**
 * Outline chip/toggle buttons used on onboarding steps (e.g. clinic size, document favourites).
 * Selected fill uses primitive sand/500 so onboarding stays warm without changing global surface-selected
 * (sidebar and the rest of the app keep semantic tokens).
 */
export function onboardingToggleButtonClassName(
  isSelected: boolean,
  extraClassName?: string
) {
  return cn(
    'border-border bg-surface text-text-primary transition-colors',
    isSelected && 'border-sand-600 bg-sand-500 hover:bg-sand-600 active:bg-sand-600',
    extraClassName
  );
}
